import config from 'configDir/index';
import { get, putQuery } from './http';

const baseUrl = '/message/center';

//  查询消息列表
const queryMessageService = get(`${baseUrl}/content/page`, config.hostUrl);

//  当日未读消息列表
const queryMessageNoreadService = get(`${baseUrl}/content/noRead/list`, config.hostUrl);

// 消息详情
const queryMessageDetailService = get(`${baseUrl}/content/detail`, config.hostUrl);

// 消息标记已读
const setMessageReadService = putQuery(`${baseUrl}/content/read`, config.hostUrl);

//  查询消息类型
const queryMessageTypeService = get(`${baseUrl}/configure/type/list`, config.hostUrl);

const queryNoReadClassifyCountService = get(
  `${baseUrl}/content/noReadClassifyCount`,
  config.hostUrl,
);

export {
  queryMessageService,
  queryMessageNoreadService,
  queryMessageDetailService,
  setMessageReadService,
  queryMessageTypeService,
  queryNoReadClassifyCountService,
};
